<template>
  <div>
    <div v-if="(getIsViewer || getIsAdministrator) && !getProjectId" class="dashboardWrapper">
      <div class="titleRow">
        <span id="titleAndProjectName">
          <h1>Projekte Übersicht</h1>
        </span>
      </div>
      <div style="display: flex; flex-direction: column; gap: 1rem; margin-top: 2rem">
        <b-card
          v-for="project in fetchedProjects"
          :key="project.id"
          class="shadow-sm"
          @click="selectProject(project)"
          style="cursor: pointer; transition: background-color 0.2s"
          onmouseover="this.style.backgroundColor='#f8f9fa';"
          onmouseout="this.style.backgroundColor='white';"
        >
          <h4 style="color: #8b69a9">{{ project.name }}</h4>
          <p class="text-muted mb-0">{{ project.description }}</p>
        </b-card>
      </div>
    </div>

    <div v-if="getIsSupervisor && !(getIsViewer || getIsAdministrator) && !getProjectId" class="dashboardWrapper">
      <div class="titleRow">
        <span id="titleAndProjectName">
          <h1>System-Übersicht</h1>
        </span>
      </div>
      <div style="margin-top: 2rem">
        <b-alert show variant="info">
          Sie sind aktuell noch keinen Projekten zugewiesen. Sobald Ihnen Projekte zugewiesen wurden, können Sie diese oben in der
          Navigationsleiste auswählen.
        </b-alert>
      </div>
    </div>

    <div v-if="getProjectId" class="dashboardWrapper">
      <div class="titleRow">
        <span id="titleAndProjectName">
          <h1>Dashboard</h1>
          <span id="projectName"> {{ getProjectName }} </span>
        </span>
        <span id="projectWeek"> {{ $t(localeConsts.projectWeek) }}: {{ getCurrentWeek }} </span>
      </div>
      <div class="dashboardGrid">
        <dashboard-card :dashboard-card-content="dashboardCardContents.importantLinksContent">
          <important-links></important-links>
        </dashboard-card>
        <dashboard-card :dashboard-card-content="dashboardCardContents.teamMembersContent"> <team-members> </team-members> </dashboard-card>
        <dashboard-card :dashboard-card-content="dashboardCardContents.statusOverviewContent">
          <status-overview></status-overview>
        </dashboard-card>
        <dashboard-card :dashboard-card-content="dashboardCardContents.workloadContent">
          <workload-overview></workload-overview>
        </dashboard-card>
      </div>
    </div>
  </div>
</template>

<script>
import DashboardCard from './DashboardCard.vue'
import TeamMembers from './CardContents/TeamMembers.vue'
import StatusOverview from './CardContents/StatusOverview.vue'
import WorkloadOverview from './CardContents/WorkloadOverview.vue'
import ImportantLinks from './CardContents/ImportantLinks.vue'
import mapGettersMixin from '../../mixins/mapGettersMixin'
import axios from '../../../axios'

export default {
  name: 'DashboardComponent',
  components: { DashboardCard, TeamMembers, StatusOverview, WorkloadOverview, ImportantLinks },
  mixins: [mapGettersMixin],
  data() {
    return {
      projectName: '',
      localeConsts: {
        importantLinks: 'DASHBOARD.IMPORTANTLINKS',
        teamMembers: 'DASHBOARD.TEAMMEMBERS',
        statusOverview: 'DASHBOARD.STATUSOVERVIEW',
        workloadOverview: 'DASHBOARD.WORKLOADOVERVIEW',
        projectWeek: 'DASHBOARD.PROJECTWEEK'
      },
      fetchedProjects: []
    }
  },
  computed: {
    dashboardCardContents() {
      return {
        importantLinksContent: {
          title: this.$i18n.t(this.localeConsts.importantLinks)
        },
        teamMembersContent: {
          title: this.$i18n.t(this.localeConsts.teamMembers)
        },
        statusOverviewContent: {
          title: this.$i18n.t(this.localeConsts.statusOverview),
          route: 'statusReports'
        },
        workloadContent: {
          title: this.$i18n.t(this.localeConsts.workloadOverview),
          route: 'workReports'
        }
      }
    },
    getIsViewer() {
      return this.$store.getters['authentication/getIsViewer']
    },
    getIsAdministrator() {
      return this.$store.getters['authentication/getIsAdministrator']
    },
    getIsSupervisor() {
      return this.$store.getters['authentication/getIsSupervisor']
    }
  },
  async created() {
    if ((this.getIsViewer || this.getIsAdministrator) && !this.getProjectId) {
      const response = await axios.get('projects/')
      this.fetchedProjects = response.data
    }
  },
  methods: {
    async selectProject(project) {
      this.$store.commit('authentication/setProjectId', project.id)
      this.$store.commit('authentication/setProjectName', project.name)
      await this.$store.dispatch('authentication/fetchStartDateOfProject')
    }
  }
}
</script>

<style>
.dashboardWrapper {
  width: -webkit-fill-available;
}

.titleRow {
  color: #8b69a9;
  display: flex;
  align-items: baseline;
  justify-content: space-between;
}

#titleAndProjectName {
  display: flex;
  align-items: baseline;
}

#projectName {
  margin-left: 20px;
  font-size: 30px;
}

#projectWeek {
  font-size: 20px;
  padding-right: 20px;
}

.dashboardGrid {
  display: grid;
  grid-template: 42% 58% / 50% 50%;
}
</style>
